import {
  CHANGE_RECIPIENTS_SEARCH_FILTER,
  DATA_UPDATE_ASYNC,
  RECIPIENTS_REQUEST_ASYNC,
} from './constants'

export const updateData = (data) => ({
  type: DATA_UPDATE_ASYNC.INITIATE,
  payload: { data },
})
export const updateDataSuccess = (data) => ({
  type: DATA_UPDATE_ASYNC.SUCCESS,
  payload: { data },
})
export const updateDataError = (error) => ({
  type: DATA_UPDATE_ASYNC.ERROR,
  error,
})
export const updateDataCancel = () => ({ type: DATA_UPDATE_ASYNC.CANCEL })

export const fetchRecipients = () => ({ type: RECIPIENTS_REQUEST_ASYNC.INITIATE })
export const fetchRecipientsSuccess = (data) => ({
  type: RECIPIENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchRecipientsError = (error) => ({
  type: RECIPIENTS_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchRecipientsCancel = () => ({ type: RECIPIENTS_REQUEST_ASYNC.CANCEL })

const changeRecipientsSearchFilter = (searchFilter) => ({
  type: CHANGE_RECIPIENTS_SEARCH_FILTER,
  payload: { searchFilter },
})

export default {
  // to props
  updateData,
  updateDataCancel,
  fetchRecipients,
  fetchRecipientsCancel,
  changeRecipientsSearchFilter,
}
